export enum SharedOn {
  NAVERBLOG = 'NAVERBLOG',
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  TWITTER = 'TWITTER',
  TUMBLR = 'TUMBLR',
  PINTEREST = 'PINTEREST',
}
